import Vue from 'vue'

export default {
    setFlatStories( state ) 
    {
        state.stories.map( function(slide, group) {
            if ( !slide.stories ) return;

            const { stories } = state.stories[group]
            Vue.set(state.stories[group], 'stories', stories.flat())
            Vue.set(state.stories[group], 'grouped', stories)
        })
    },
}